import createStore from "astrid-helpers/src/createStore";

export const [getProofing, setProofing, useProofing, onProofing] = createStore(true);
